module.exports = __webpack_public_path__ + "img/5.9551a3b5.jpg";